import {Injectable, Injector} from "@angular/core";
import {DxSessionService} from "./dx-session.service";
import {DxAuthStrategyType} from "../config/dx-auth-stategy-type";
import {DxAuthenticationStrategy} from "./strategy/auth/dx-authentication-strategy";
import {DxAppError} from "../../dx-core/domain/error/dx-app-error";
import {DxBasicAuthenticationStrategy} from "./strategy/auth/dx-basic-authentication-strategy";
import {DX_AUTH_CONFIG} from "../config/dx-auth-config";
import {Observable} from "rxjs/index";
import {DxAuthentication} from "../domain/authentication/dx-athentication";
import {tap} from "rxjs/internal/operators";
import {DxOperationResultType} from "../../dx-core/domain/common/dx-operation-result-type";
import {DxLogger} from "../../dx-core/services/dx-logger.service";
import {DxKeycloakAuthenticationStrategy} from "./strategy/auth/dx-keycloak-authentication-strategy";
import {DxLogoutStrategy} from "./strategy/logout/dx-logout-strategy";
import {DxSyncLogoutStrategy} from "./strategy/logout/dx-sync-logout-strategy";
import {DxLogoutResult} from "../domain/authentication/dx-logout-result";
import {DxLogoutStrategyType} from "../config/dx-logout-strategy-type";
import {DxAsyncLogoutStrategy} from "./strategy/logout/dx-аsync-logout-strategy";
import {DxServerDefinedAuthenticationStrategy} from "./strategy/auth/dx-server-defined-authentication-strategy";



@Injectable()
export class DxAuthService {
  /** Текущая стратегия аутентификации в приложении */
  private _authStrategy: DxAuthenticationStrategy;
  /** Текущая стратегия выхода из системы */
  private _logoutStrategy: DxLogoutStrategy;


  constructor(private _injector: Injector,
              private _sessionService: DxSessionService,
              private _logger: DxLogger) {
    const config = this._injector.get(DX_AUTH_CONFIG);
    if (config) {
      this._authStrategy = DxAuthService._dispatchAuthStrategy(this._injector, config.authStrategyType);
      this._logoutStrategy = DxAuthService._dispatchLogoutStrategy(this._injector, config.logoutStrategyType);
    } else {
      this._authStrategy = this._injector.get(DxBasicAuthenticationStrategy);
      this._logoutStrategy = this._injector.get(DxSyncLogoutStrategy);
    }
  }


  public login(login: string, password: string): Observable<DxAuthentication> {
    return this._authStrategy.authenticate(login, password).pipe(
      tap(auth => {
        if (DxOperationResultType.SUCCESS == auth.authResult) {
          try {
            this._sessionService.createSession(auth.user);
          } catch (exception) {
            this._logger.debug(exception);
          }
        }
      }));
  }


  // TODO: Подумать над уровнем выброса исключения в случае провала логаута
  public logout(): Observable<DxLogoutResult> {
    return this._logoutStrategy.logout();
  }


  private static _dispatchAuthStrategy(injector: Injector, type: DxAuthStrategyType): DxAuthenticationStrategy {
    switch (type) {
      case DxAuthStrategyType.BASIC_AUTH:
        return injector.get(DxBasicAuthenticationStrategy);
      case DxAuthStrategyType.JWT_TOKEN_AUTH:
        return injector.get(DxBasicAuthenticationStrategy);
      case DxAuthStrategyType.DOMAIN_AUTH:
        return injector.get(DxBasicAuthenticationStrategy);
      case DxAuthStrategyType.OAUTH2:
        return injector.get(DxBasicAuthenticationStrategy);
      case DxAuthStrategyType.KEY_CLOAK_AUTH:
        return injector.get(DxKeycloakAuthenticationStrategy);
      case DxAuthStrategyType.SERVER_DEFINED:
        return injector.get(DxServerDefinedAuthenticationStrategy);
      default:
        const error = new DxAppError();
        error.message = 'Передан неподдерживаемый тип стратегии аутентификации пользователя!';
        throw error;
    }
  }


  private static _dispatchLogoutStrategy(injector: Injector, type: DxLogoutStrategyType): DxLogoutStrategy {
    switch (type) {
      case DxLogoutStrategyType.SYNC:
        return injector.get(DxSyncLogoutStrategy);
      case DxLogoutStrategyType.ASYNC:
        return injector.get(DxAsyncLogoutStrategy);
      default:
        const error = new DxAppError();
        error.message = 'Передан неподдерживаемый тип стратегии завершения работы приложения!';
        throw error;
    }
  }
}
